import { CheckboxField, FormLayout, InputField } from '@app/lib/form'
import { Component } from '@contember/interface'
import { LocaleSideDimension } from '../locale-side-dimension'

export const DomainForm = Component(() => (
	<FormLayout>
		<LocaleSideDimension>
			<InputField
				field="domain"
				label="Domain"
				inputProps={{
					placeholder: 'https://vshosting.cz',
				}}
				required
			/>
			<CheckboxField field="suppressSubmissionForms" label="Suppress sending emails from submission forms actions" defaultValue={false} />
		</LocaleSideDimension>
	</FormLayout>
))
